import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card"]

  complete(event) {
    event.preventDefault()
    event.stopPropagation()

    const button = event.currentTarget
    const taskId = button.dataset.taskId
    const dueDate = button.dataset.dueDate
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    const formData = new URLSearchParams()
    formData.append('complete', 'true')
    formData.append('due_date', dueDate)

    const isShowPage = button.dataset.redirect === 'true'

    fetch(`/member/tasks/${taskId}/completion`, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': csrfToken
      },
      body: formData
    }).then(response => {
      if (response.ok) {
        if (isShowPage) {
          window.location.href = '/member/tasks'
        } else {
          const card = button.closest('[data-task-target="card"]')
          if (card) {
            card.style.transition = 'opacity 0.3s, transform 0.3s'
            card.style.opacity = '0'
            card.style.transform = 'translateX(-20px)'
            setTimeout(() => {
              const wrapper = card.parentElement
              if (wrapper) wrapper.remove()
            }, 300)
          }
        }
      }
    })
  }
}
